module.exports = __webpack_public_path__ + "static/media/cementTruck_indigo.c74077a2.svg";